import { useCallback, useEffect, useState } from 'react';
import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import type CardType from '@alltrails/types/CardType';
import getCardPhotoUrl from '@alltrails/core/utils/getCardPhotoUrl';

const useCardPhotos = (cardType: CardType, id: number, size: PhotoSizeDimensions, maxPhotos: number) => {
  const [photos, setPhotos] = useState<string[]>([]);
  const [photosLoaded, setPhotosLoaded] = useState(false);

  useEffect(() => {
    if (maxPhotos < 1) {
      setPhotos([]);
      setPhotosLoaded(true);
    } else {
      const initialPhoto = getCardPhotoUrl({ cardType, id, index: 0, size });
      if (maxPhotos === 1) {
        setPhotos([initialPhoto]);
        setPhotosLoaded(true);
      } else {
        const fillerPhotos = Array(maxPhotos - 1).fill('') as string[];
        setPhotos([initialPhoto, ...fillerPhotos]);
        setPhotosLoaded(false);
      }
    }
  }, [size, maxPhotos, cardType, id]);

  const loadPhotos = useCallback(() => {
    if (!photosLoaded) {
      setPhotosLoaded(true);

      const urls = photos.map((_, index) => {
        const url = getCardPhotoUrl({ cardType, id, index, size });
        // pre-load images by browser
        try {
          new Image().src = url;
        } catch {
          // silently catch
        }
        return url;
      });

      setPhotos(urls);
    }
  }, [cardType, id, photos, photosLoaded, size]);

  return { photos, loadPhotos };
};

export default useCardPhotos;
